import { HisBaseGlobalsService } from './../../../core/service/base/his-base-globals.service';
import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { HisDynamicFieldBase } from '../../model/field-base';
import { HisDynamicFieldConfig } from '../../model/formfield';
import { HisDynamicFieldConfigAndData } from '../../model/field-config-and-data';
import { SelectItem } from 'primeng/api';

@Component( {
    template: `
    <his-plam [label]="options.label" [helptext]="options.helptext">
      <form [formGroup]="localFormGroup">
        @for (opt of items; track opt) {
          <div>
            <input #content
              [hisDdKey]="options.ddKey"
              type="radio"
              formControlName="value"
              [value]="opt.value"
              class="biaRadioButton"
              />
            {{opt.label}}
          </div>
        }
      </form>
    </his-plam>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class RadioButtonComponent extends HisDynamicFieldBase<HisDynamicFieldConfig> implements OnInit {

    currentItem: SelectItem;
    items: SelectItem[];
    localFormGroup: UntypedFormGroup;
    options: HisDynamicFieldConfig;

    constructor() {
        const injectedData = inject<HisDynamicFieldConfigAndData>('injectedData' as any);
        const hbgs = inject(HisBaseGlobalsService);

        super( injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs );
        this.options = injectedData.options;
    }

    ngOnInit() {
        this.items = this.options.items;
        this.currentItem = this.items.find( it => this.value === it.value ) || { label: '', value: '' };

        this.localFormGroup = new UntypedFormGroup( {
            value: this.required ? new UntypedFormControl( this.currentItem.value, Validators.required )
                : new UntypedFormControl( this.currentItem.value ),
        } );
        this.formGroup.addControl( this.name, this.localFormGroup );
    }

    updateConfiguration( entireFormConfig: HisDynamicFieldConfig ) {
        let matchingConfig = this.searchFieldConfig( entireFormConfig );
        if ( matchingConfig !== null ) {
            this.items = matchingConfig.items;
            this.currentItem = this.items.find( it => matchingConfig.defaultValue === it.value ) || { label: '', value: '' };
            this.localFormGroup.removeControl( this.name );
            this.formControl.setValue( matchingConfig.defaultValue, { emitEvent: false } );
        }
    }

    getControlValue(): any {
        return this.localFormGroup.value.value;
    }
}

// @for (item of items; track item) {
// <div>
// <p-radioButton #content
// [name]="name"
// [formControl]="formControl"
// [value]="item.value"
// class="plamOptionVertical"
// [label]="item.label"
// [required]="options.required">
// </p-radioButton>
// </div>
// }
